(function () {
  function parseList(str) {
    return (str || '').split(',').map(s => s.trim()).filter(Boolean);
  }

  function initForButton(customizeBtn) {
    const optionSetId = (customizeBtn.getAttribute('data-gpo-option-set-id') || '').trim();
    const required = parseList(customizeBtn.getAttribute('data-gpo-required-fields'));

    // If metafields not set, do nothing (button stays normal)
    if (!optionSetId || required.length === 0) return false;

    // Find matching GPO app for this product/page
    const gpoApp = document.querySelector(`.gpo-app[data-option-set-id="${optionSetId}"]`);
    if (!gpoApp) return false;

    // prevent double init
    if (customizeBtn.dataset.gpoGuardInit === '1') return true;
    customizeBtn.dataset.gpoGuardInit = '1';

    // message element (placed after button, no layout changes)
    let msg = customizeBtn.parentElement.querySelector('.cus-required-msg');
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'cus-required-msg';
      msg.innerText = 'Please first select the required variant options above';
      customizeBtn.insertAdjacentElement('afterend', msg);
    }

    function validate() {
      // SAME logic as your working code
      const isValid = required.every(name =>
        gpoApp.querySelector(`input[name="${name}"]:checked`)
      );

      // The key part that stops redirect in your theme
      customizeBtn.style.pointerEvents = isValid ? 'auto' : 'none';
      customizeBtn.style.opacity = isValid ? '1' : '0.6';
      msg.style.display = isValid ? 'none' : 'block';
    }

    validate();
    gpoApp.addEventListener('change', validate);

    const innerObserver = new MutationObserver(validate);
    innerObserver.observe(gpoApp, { childList: true, subtree: true });

    return true;
  }

  function initAll() {
    document
      .querySelectorAll('sa-customize-frame-button.m-product-customize-frame[data-gpo-option-set-id]')
      .forEach(initForButton);
  }

  // initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // in case GPO loads late
  const observer = new MutationObserver(() => initAll());
  observer.observe(document.body, { childList: true, subtree: true });
})();
